import React, { useState } from "react";
import logo from "../../src/Images/img/logo.png";
import * as query from "../query";
import ClipLoader from "react-spinners/ClipLoader";
import { FaCircleCheck, FaCircleExclamation } from "react-icons/fa6";

function DeleteAccountRequest() {
  const [process, setProcess] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [formData, setFormData] = useState({
    nameInput: "",
    emailInput: "",
    reasonInput: "",
  });
  //console.log(vcode);

  const handleSubmit = (event) => {
    event.preventDefault();
    let $name = formData.nameInput;
    let $email = formData.emailInput;
    let $reason = formData.reasonInput;
    setProcess(false);

    if ($name !== "" && $email !== "") {
      setShowAlert(false);
      setProcess(true);
      sendRequestEmail($email, $name, $reason);
    } else {
      setAlertMsg("Name and Email Address cannot be empty.");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setShowAlert(false);
  };

  const sendRequestEmail = async (email, name, reason) => {
    const response = await query.fetchOpenRequest(
      "api/share/email/request/delete/send",
      {
        email,
        name,
        reason,
      }
    );
    if (!response.ok) {
      const resData = await response.json();

      if (resData.response.code === 500) {
        setProcess(false);
        throw new Error(resData.response.errorMessage);
      } else throw new Error("something went wrong!");
    }

    const resData = await response.json();

    if (resData.result.result === true) {
      setProcess(false);
      setCompleted(true);
      setSuccess(true);
      setFormData({
        nameInput: "",
        emailInput: "",
        reasonInput: "",
      });
    } else {
      setProcess(false);
      setCompleted(true);
      setSuccess(false);
      setFormData({
        nameInput: "",
        emailInput: "",
        reasonInput: "",
      });
    }
  };

  return (
    <div>
      <header
        id="js-header"
        class="u-header u-header--sticky-top u-header--show-hide u-header--toggle-section"
        data-header-fix-moment="100"
        data-header-fix-effect="slide"
      >
        <div class="u-header__section u-shadow-v27 g-bg-white g-transition-0_3 g-py-12 g-py-20--md">
          <nav class="navbar navbar-expand-lg py-0 g-px-15">
            <div class="container g-pos-rel">
              <a href={"https://www.questquote.com"}>
                <img
                  class="u-header__logo-img u-header__logo-img--main g-width-200"
                  src={logo}
                  alt="Questquote logo"
                />
              </a>
            </div>
          </nav>
        </div>
      </header>

      {completed ? (
        <div>
          {success ? (
            <section class="g-bg-gray-light-v5">
              <div class="container g-py-100">
                <div class="row justify-content-center">
                  <div class="col-sm-8 col-lg-5">
                    <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                      <header class="text-center mb-4">
                        <div class="g-mb-35">
                          <FaCircleCheck size={60} color={"#2ECC71"} />
                        </div>
                        <h3 class="h3 g-color-black g-font-weight-600">
                          Process Completed!
                        </h3>
                      </header>
                      <div class="g-mb-35" style={{ textAlign: "center" }}>
                        <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-18">
                          Your request has been successfully submitted to us.
                        </label>
                        <label class="g-color-gray-dark-v2 g-font-weight-300 g-font-size-18">
                          We will contact you within the next 3 business days
                          for final confirmation.
                        </label>
                      </div>
                      <div class="g-mb-10" style={{ textAlign: "center" }}>
                        <a
                          href={"https://www.questquote.com"}
                          class="btn btn-md btn-block u-btn-primary rounded g-py-13"
                        >
                          Back to main
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section class="g-bg-gray-light-v5">
              <div class="container g-py-100">
                <div class="row justify-content-center">
                  <div class="col-sm-8 col-lg-5">
                    <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                      <header class="text-center mb-4">
                        <div class="g-mb-35">
                          <FaCircleExclamation size={60} color={"#F39C12"} />
                        </div>
                        <h3 class="h3 g-color-black g-font-weight-600">
                          Process Failure!
                        </h3>
                      </header>
                      <div class="g-mb-35" style={{ textAlign: "center" }}>
                        <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-18">
                          Your password for data delete request has failed.
                        </label>
                        <label class="g-color-gray-dark-v2 g-font-weight-300 g-font-size-18">
                          Please try again later, or contact our support email
                          directly: support@questquote.net
                        </label>
                      </div>
                      <div class="g-mb-10" style={{ textAlign: "center" }}>
                        <a
                          href={"https://www.questquote.com"}
                          class="btn btn-md btn-block u-btn-primary rounded g-py-13"
                        >
                          Back to main
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      ) : (
        <section id="home" class="g-theme-bg-gray-light-v1 g-pt-90">
          <div class="container g-width-600">
            <div class="text-md-left">
              <h1> Delete Your Account </h1>
              <p>
                We respect your privacy and are committed to protecting your
                personal data. If you would like to request the deletion of your
                account and all associated data, please fill out the form below.
                Once we receive your request, we will process it within 3 days
                and confirm the deletion via email.
              </p>
              {process ? (
                <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30 g-mb-100">
                  <header class="text-center mb-4">
                    <h2 class="h2 g-color-black g-font-weight-600">
                      Processing...
                    </h2>
                  </header>
                  <div class="g-py-60 text-center">
                    <ClipLoader
                      color={"#2ECC71"}
                      loading={process}
                      size={120}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div>
                </div>
              ) : (
                <div class="u-shadow-v21 g-bg-white rounded g-py-40 g-px-30">
                  <header class="text-center mb-4">
                    <h5 class="h5 g-color-black g-font-weight-600">
                      Delete Account Request Form
                    </h5>
                  </header>
                  <form class="g-py-15" onSubmit={handleSubmit}>
                    <div class="mb-4" style={{ textAlign: "left" }}>
                      <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                        Name:
                      </label>
                      <input
                        class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15"
                        type="text"
                        name="nameInput"
                        id="nameInput"
                        value={formData.nameInput}
                        onChange={handleChange}
                      />
                    </div>

                    <div class="g-mb-35" style={{ textAlign: "left" }}>
                      <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                        Email Address:
                      </label>
                      <input
                        class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15 mb-3"
                        type="email"
                        name="emailInput"
                        id="emailInput"
                        value={formData.emailInput}
                        onChange={handleChange}
                      />
                    </div>

                    <div class="g-mb-35" style={{ textAlign: "left" }}>
                      <label class="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                        Reason for Deletion(optional):
                      </label>
                      <input
                        class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15 mb-3"
                        type="text"
                        name="reasonInput"
                        id="reasonInput"
                        value={formData.reasonInput}
                        onChange={handleChange}
                      />
                    </div>

                    <div class="g-mb-35" style={{ textAlign: "left" }}>
                      <label class="g-color-gray-dark-v2 g-font-weight-300 g-font-size-13">
                        Instructions for Deletion Please note that deleting your
                        account will permanently remove all your data from our
                        systems, including any saved preferences, purchase
                        history, and other personalized information. This action
                        is irreversible. If you have any questions or need
                        assistance, please contact our support team at
                        support@questquote.net.
                      </label>
                    </div>

                    <div class="mb-4">
                      {process === true ? (
                        <button
                          class="btn btn-md btn-block u-btn-primary rounded g-py-13"
                          type="button"
                          disabled
                        >
                          Submitting
                        </button>
                      ) : (
                        <button
                          class="btn btn-md btn-block u-btn-primary rounded g-py-13"
                          type="submit"
                        >
                          Submit
                        </button>
                      )}
                    </div>

                    {showAlert && (
                      <div
                        class="alert alert-danger g-mt-30--lg"
                        role="alert"
                        style={{ textAlign: "left" }}
                      >
                        <strong>{alertMsg}</strong>
                      </div>
                    )}
                  </form>
                </div>
              )}
            </div>
          </div>
        </section>
      )}
      <a
        class="js-go-to u-go-to-v1"
        href={() => false}
        data-type="fixed"
        data-position='{
     "bottom": 15,
     "right": 15
   }'
        data-offset-top="400"
        data-compensation="#js-header"
        data-show-effect="zoomIn"
      >
        <i class="hs-icon hs-icon-arrow-top"></i>
      </a>
    </div>
  );
}

export default DeleteAccountRequest;
